import gql from 'graphql-tag'

export const getCallLogs = gql`
  query($paging: PagingQuery, $order: CallLogsOrder, $filter: CallLogsFilter!) {
    getCallLogs(
      filter: $filter,
      order: $order,
      paging: $paging
    ) {
      logs {
        id
        logId
        zoomUserId
        direction
        callerNumber
        callerName
        calleeNumber
        calleeName
        detailStr
        createdAt
        updatedAt
        duration
        result
        dateTime
      }
      paging{ totalCount currentOffset currentLimit }
    }
  }
`

export const searchAccountsAndContacts = gql`
  query($countryCallingCode: String!, $phone: String!) {
    searchAccountsAndContacts(
      countryCallingCode: $countryCallingCode,
      phone: $phone
    ) {
      accounts {
        id
        name
      }
      contacts {
        contact {
          id
          name
        }
        accounts {
          id
          name
        }
      }
    }
  }
`
